import { Components, Theme } from "@mui/material";

export const MuiInputAdornment: Components<
  Omit<Theme, "MuiInputAdornment">
>["MuiInputAdornment"] = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "row",
      gap: ".25rem",
      alignItems: "center",
    },
  },
};
